module.exports = __webpack_public_path__ + "static/img/404.bfb6a8e2.png";